module.exports = __webpack_public_path__ + "static/barbarawork5-d3e2f32c8516f5b44395e15a176efef1.jpg";